"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DetailsMessage = (0, _styledComponents.default)(_styledComponents.default.p(_alloyReactTheme.default.typography.bodySmall))`
  color: ${_alloyReactTheme.default.colors.charcoal700};
  margin: 0 14px;
  text-align: center;
`;
var _default = exports.default = DetailsMessage;